interface PublishableProduct {
  createdAt: string;
  publishedAt?: string | null;
}

/**
 * The date an announcement went live. Falls back to the creation date for
 * products saved before publishedAt existed.
 */
export const getPublishedAt = (product: PublishableProduct): string =>
  product.publishedAt || product.createdAt;
